import React, { useState, useEffect } from "react";
import "../Pages/Styles/Trainer.css";
import { BsPersonCircle } from "react-icons/bs";
import { TfiLocationPin } from "react-icons/tfi";
import CourseGrid from "./EventGrid";
import { BiSolidPlusCircle } from "react-icons/bi";
import axiosConfig from "../Service/axiosConfig";
import { MdOutlineLocalPhone } from "react-icons/md";
import { MdOutlineMailOutline } from "react-icons/md";
const Trainer = () => {
  const [activeTab, setActiveTab] = useState("Courses");
  const [getTrainer, setGetTrainer] = useState([]);

  useEffect(() => {
    const getTrainerData = async () => {
      try {
        const response = await axiosConfig.get("/accounts/get_trainer/");
        setGetTrainer(response.data.results);
        // console.log(getTrainer, "te");
      } catch (error) {
        console.log(error);
      }
    };
    getTrainerData();
  }, []);

  return (
    <>
      <section className="trainer-section">
        <div className="profile-section">
          <section>
            <div className="cover-image">
              <img
                src={require("../Pages/images/trainer-banner.webp")}
                alt="Cover"
              />
            </div>
          </section>
          <section>
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  {console.log(getTrainer, "trainer")}
                  {getTrainer &&
                    getTrainer.length > 0 &&
                    getTrainer.map((trainer, index) => {
                      return (
                        <div className="profile-info" key={index}>
                          <img
                            src={trainer?.profile_picture}
                            alt={trainer?.full_name}
                            className="profile-pic"
                          />

                          <div className="profile-details">
                            <h2>{trainer?.full_name}</h2>
                            <div className="d-flex flex-column">
                              <div className="profile-data">
                                <BsPersonCircle size={15} />
                                <p className="role">{trainer?.bio}</p>
                              </div>
                              {trainer?.email && (
                                <div className="profile-data">
                                  <MdOutlineMailOutline size={15} />
                                  <p className="company">{trainer?.email}</p>
                                </div>
                              )}

                              {trainer?.mobileno && (
                                <div className="profile-data">
                                  <MdOutlineLocalPhone size={15} />
                                  <p className="company">{trainer?.mobileno}</p>
                                </div>
                              )}
                              {trainer?.state && trainer?.country && (
                                <div className="profile-data">
                                  <TfiLocationPin size={15} />{" "}
                                  <p className="location">{trainer?.state},</p>
                                  <p className="location">{trainer?.country}</p>
                                </div>
                              )}
                            </div>
                            <div className="about-section">
                              <h3>About Me</h3>
                              <p>{trainer?.description}</p>
                            </div>
                            <button className="edit-profile-btn">
                              Edit Profile
                            </button>
                          </div>
                        </div>
                      );
                    })}
                </div>

                <div className="col-md-8">
                  <div className="tabs">
                    <button
                      className={`tab ${
                        activeTab === "Courses" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("Courses")}
                    >
                      Courses
                    </button>
                    <button
                      className={`tab ${
                        activeTab === "Your Stats" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("Your Stats")}
                    >
                      Your Stats
                    </button>
                    <button
                      className={`tab ${
                        activeTab === "Drafts" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("Drafts")}
                    >
                      Drafts
                    </button>
                  </div>

                  {activeTab === "Drafts" && (
                    <div className="create-course-div">
                      <div className="create-course-icon-div">
                        <BiSolidPlusCircle
                          size={40}
                          style={{ color: "#5751E1" }}
                        />
                      </div>
                      <button className="create-course-btn">
                        Create A Course
                      </button>
                      <p className="create-course-p">
                        Unpublished course will appear here
                      </p>
                    </div>
                  )}
                  {activeTab === "Courses" && (
                    <div className="course-grid-container">
                      <CourseGrid />
                    </div>
                  )}

                  {activeTab === "Your Stats" && (
                    <div>
                      <p>Your stats content goes here...</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </>
  );
};

export { Trainer };
